import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Footer from './Footer';
import Navbar from './Navbar';
import { useDispatch, useSelector } from 'react-redux';
import { useEffect } from "react";
import { getNotic } from "../Store/ActionCreators/NotifactionActionCreator";
import { Link } from "react-router-dom";
import {
  Box,
  Grid,
  Typography,
  Card,
  CardContent
} from "@mui/material";
import Newsletter from "../Page/NewsLetter";
import Contact from "../Page/ContactPage";
import SearchPage from "../Page/SearchPage";

const gradients = [
  "linear-gradient(135deg, #e74c3c, #f39c12)",
  "linear-gradient(135deg, #2ecc71, #f71414ff)",
  "linear-gradient(135deg, #3498db, #9b59b6)",
  "linear-gradient(135deg, #f39c12, #20160eff)",
  "linear-gradient(135deg, #a911e6ff, #3321ceff)",
  "linear-gradient(135deg, #1abc9c, #121dbdff)"
];

const features = [
  { icon: "📄", title: "Sarkari Jobs", desc: "Latest government job updates." },
  { icon: "🪪", title: "Admit Card", desc: "Download admit cards easily." },
  { icon: "📊", title: "Results", desc: "All Sarkari exam results." },
  { icon: "📘", title: "Syllabus", desc: "Updated syllabus & exam pattern." },
  { icon: "🗝️", title: "Answer Key", desc: "Official answer keys." },
  { icon: "🎓", title: "Scholarship", desc: "Scholarship application support." },
  { icon: "🏫", title: "Admission", desc: "College & university admissions." },
  { icon: "📢", title: "Exam Alerts", desc: "Important exam notifications." },
  { icon: "⏳", title: "Upcoming Job", desc: "Upcoming government job." },
  { icon: "🏛️", title: "University Update", desc: "university news & updates." },
  { icon: "🏠", title: "Sarkari Yojana", desc: "Government schemes & benefits." },
  { icon: "📂", title: "Documents", desc: "Important document services." }
];


export default function Home() {
    const dispatch = useDispatch()
    const Notifactionlist = useSelector((state)=>state.NoticStateData)

    const admitCard = Notifactionlist.filter(item => item.category === "Admit Card");
    const latestJob = Notifactionlist.filter(item => item.category === "Latest Job");
    const answerKey = Notifactionlist.filter(item => item.category === "Answer Key");
    const admission = Notifactionlist.filter(item => item.category === "Admission");
    const result = Notifactionlist.filter(item => item.category === "Result");
    const important = Notifactionlist.filter(item => item.category === "Important");
    const syllabus = Notifactionlist.filter(item => item.category === "Syllabus");
    const university_Update = Notifactionlist.filter(item => item.category === "University Update");
    const upcoming_Job = Notifactionlist.filter(item => item.category === "Upcoming Job");
    const scholarship = Notifactionlist.filter(item => item.category === "Scholarship");
    const new_Update = Notifactionlist.filter(item => item.category === "New Update");
    const sarkari_Yojana = Notifactionlist.filter(item => item.category === "Sarkari Yojana");
    const documents = Notifactionlist.filter(item => item.category === "Documents");
    const latest_Blog = Notifactionlist.filter(item => item.category === "Latest Blog");

// Required categories for slider
const importantCategories = ["Admit Card", "Latest Job", "Answer Key", "Scholarship", "Admission", "Result", "Important", "Important", "Syllabus", "University Update", "Upcoming Job", "New Update", "Sarkari Yojana", "Documents", "Latest Blog"];

// Filter + sort latest
const recentUpdates = Notifactionlist
    .filter(item => importantCategories.includes(item.category))
    .sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt))
    .slice(0, 6); // show first 6 items for slider

    useEffect(()=>{
        dispatch(getNotic())
    },[dispatch])


    const settings = {
        dots: false,
        infinite: true,
        speed: 500,
        autoplay: true,
        autoplaySpeed: 2000,
        slidesToShow: 6,
        slidesToScroll: 1,
        responsive: [
            {
                breakpoint: 1024,
                settings: { slidesToShow: 2 }
            },
            {
                breakpoint: 768,
                settings: { slidesToShow: 4 }
            },
            {
                breakpoint: 576,
                settings: { slidesToShow: 3 }
            }
        ]
    };
    // Dummy slide data
    const slides = recentUpdates.map(item => ({
        _id: item._id,          // 🔥 add this
        name: item.category,
        message: item.titlename
    }));



    return (
        <>
        {/* <BreackingBar/> */}
            <Navbar />
            <div className="homeItem">
                 <div style={{ paddingTop: "20px", width: "100%", overflow: "hidden" }}>
                    <Slider {...settings}>
                        {slides.map((slide, index) => (
                            <div key={index}>
                                <div
                                    style={{
                                        background: gradients[index % gradients.length],
                                        padding: "10px",
                                        borderRadius: "10px",
                                        color: "#fff",
                                        textAlign: "center",
                                        minHeight: "150px",
                                        margin: "0 3px",
                                        transition: "all 0.3s ease",
                                    }}
                                >
                                    {/* <h6>{slide.name}</h6> */}
                                    <Typography sx={{ fontSize: {xs:"12px",sm:"15px",md:"18px",lg:"22px"},  fontWeight: 700,lineHeight: 1.2}}>{slide.name}</Typography>
                                        <Typography sx={{ fontSize: {xs:"10px",sm:"11px",md:"13px",lg:"15px"},          marginTop:"25px" }}><Link
                                            to={`/notifactionview/${slide._id}`}
                                            style={{ textDecoration: "none", color: "#fff" }}
                                        >
                                            {slide.message}
                                        </Link>
                                    </Typography>
                                </div>
                            </div>
                        ))}
                    </Slider>
                </div>
                <SearchPage/>
                <div className="HomecardItem mt-3">
                    <div className="row row-cols-2 row-cols-md-3">
                        <div className="col mt-3">
                            <div className="card cardItem">
                                <h6 className="title bg-danger text-white p-2 text-center">Admit Card</h6>
                                {admitCard.length > 0 ? admitCard.map((n, i) => (
                                    <p key={i} style={{fontWeight:"bold"}}>
                                        <Link to={`/notifactionview/${n._id}`} target="_blank">{n.titlename}</Link>
                                    </p>
                                )) : <p>No Admit Card Available</p>}
                                 <div className="BtnView" style={{ display: "flex", justifyContent: "flex-end",margin:"10px" }}>
                                    <Link to="/admitcard" style={{
                                        padding: "6px 40px",
                                        backgroundImage: "linear-gradient(135deg, #1976d2, #cc07abff)",
                                        color: "#fff",
                                        borderRadius: "6px",
                                        textDecoration: "none",
                                        fontWeight: 500,
                                        display: "inline-block"
                                    }}        
                                    >View All</Link>
                                </div>
                            </div>
                        </div>
                        <div className="col mt-3">
                            <div className="card cardItem">
                               <h6 className="title bg-danger text-white p-2 text-center">Latest Job</h6>
                                {latestJob.length > 0 ? latestJob.map((n, i) => (
                                    <p key={i} style={{fontWeight:"bold"}}>
                                        <Link to={`/notifactionview/${n._id}`} target="_blank">{n.titlename}</Link>
                                    </p>
                                )) : <p>No Lasted Job Available</p>}
                                <div className="BtnView" style={{ display: "flex", justifyContent: "flex-end",margin:"10px" }}>
                                    <Link to="/latestjob" style={{
                                        padding: "6px 40px",
                                        backgroundImage: "linear-gradient(135deg, #1976d2, #cc07abff)",
                                        color: "#fff",
                                        borderRadius: "6px",
                                        textDecoration: "none",
                                        fontWeight: 500,
                                        display: "inline-block"
                                    }}        
                                    >View All</Link>
                                </div>
                            </div>
                        </div>
                        <div className="col mt-3">
                            <div className="card cardItem">
                                <h6 className="title bg-danger text-white p-2 text-center">Answer Key</h6>
                                {answerKey.length > 0 ? answerKey.map((n, i) => (
                                    <p key={i} style={{fontWeight:"bold"}}>
                                        <Link to={`/notifactionview/${n._id}`} target="_blank">{n.titlename}</Link>
                                    </p>
                                )) : <p>No Answer Key Available</p>}
                                <div className="BtnView" style={{ display: "flex", justifyContent: "flex-end",margin:"10px" }}>
                                    <Link to="/answerkey" style={{
                                        padding: "6px 40px",
                                        backgroundImage: "linear-gradient(135deg, #1976d2, #cc07abff)",
                                        color: "#fff",
                                        borderRadius: "6px",
                                        textDecoration: "none",
                                        fontWeight: 500,
                                        display: "inline-block"
                                    }}        
                                    >View All</Link>
                                </div>
                            </div>
                        </div>
                        <div className="col mt-3">
                            <div className="card cardItem">
                                <h6 className="title bg-danger text-white p-2 text-center">Scholarship</h6>
                                {scholarship.length > 0 ? scholarship.map((n, i) => (
                                    <p key={i} style={{fontWeight:"bold"}}>
                                        <Link to={`/notifactionview/${n._id}`} target="_blank">{n.titlename}</Link>
                                    </p>
                                )) : <p>No Answer Key Available</p>}
                                <div className="BtnView" style={{ display: "flex", justifyContent: "flex-end",margin:"10px" }}>
                                    <Link to="/scholarship" style={{
                                        padding: "6px 40px",
                                        backgroundImage: "linear-gradient(135deg, #1976d2, #cc07abff)",
                                        color: "#fff",
                                        borderRadius: "6px",
                                        textDecoration: "none",
                                        fontWeight: 500,
                                        display: "inline-block"
                                    }}        
                                    >View All</Link>
                                </div>
                            </div>
                        </div>
                        <div className="col mt-3">
                            <div className="card cardItem">
                                <h6 className="title bg-danger text-white p-2 text-center">Admission</h6>
                                {admission.length > 0 ? admission.map((n, i) => (
                                    <p key={i} style={{fontWeight:"bold"}}>
                                        <Link to={`/notifactionview/${n._id}`} target="_blank">{n.titlename}</Link>
                                    </p>
                                )) : <p>No Answer Key Available</p>}
                                <div className="BtnView" style={{ display: "flex", justifyContent: "flex-end",margin:"10px" }}>
                                    <Link to="/admission" style={{
                                        padding: "6px 40px",
                                        backgroundImage: "linear-gradient(135deg, #1976d2, #cc07abff)",
                                        color: "#fff",
                                        borderRadius: "6px",
                                        textDecoration: "none",
                                        fontWeight: 500,
                                        display: "inline-block"
                                    }}        
                                    >View All</Link>
                                </div>
                            </div>
                        </div>
                        <div className="col mt-3">
                            <div className="card cardItem">
                                <h6 className="title bg-danger text-white p-2 text-center">Result</h6>
                                {result.length > 0 ? result.map((n, i) => (
                                    <p key={i} style={{fontWeight:"bold"}}>
                                        <Link to={`/notifactionview/${n._id}`} target="_blank">{n.titlename}</Link>
                                    </p>
                                )) : <p>No Answer Key Available</p>}
                                 <div className="BtnView" style={{ display: "flex", justifyContent: "flex-end",margin:"10px" }}>
                                    <Link to="/result" style={{
                                        padding: "6px 40px",
                                        backgroundImage: "linear-gradient(135deg, #1976d2, #cc07abff)",
                                        color: "#fff",
                                        borderRadius: "6px",
                                        textDecoration: "none",
                                        fontWeight: 500,
                                        display: "inline-block"
                                    }}        
                                    >View All</Link>
                                </div>
                            </div>
                        </div>
                        <div className="col mt-3">
                            <div className="card cardItem">
                                <h6 className="title bg-danger text-white p-2 text-center">Important</h6>
                                {important.length > 0 ? important.map((n, i) => (
                                    <p key={i} style={{fontWeight:"bold"}}>
                                        <Link to={`/notifactionview/${n._id}`} target="_blank">{n.titlename}</Link>
                                    </p>
                                )) : <p>No Answer Key Available</p>}
                                 <div className="BtnView" style={{ display: "flex", justifyContent: "flex-end",margin:"10px" }}>
                                    <Link to="/important" style={{
                                        padding: "6px 40px",
                                        backgroundImage: "linear-gradient(135deg, #1976d2, #cc07abff)",
                                        color: "#fff",
                                        borderRadius: "6px",
                                        textDecoration: "none",
                                        fontWeight: 500,
                                        display: "inline-block"
                                    }}        
                                    >View All</Link>
                                </div>
                            </div>
                        </div>
                        <div className="col mt-3">
                            <div className="card cardItem">
                                <h6 className="title bg-danger text-white p-2 text-center">Syllabus</h6>
                                {syllabus.length > 0 ? syllabus.map((n, i) => (
                                    <p key={i} style={{fontWeight:"bold"}}>
                                        <Link to={`/notifactionview/${n._id}`} target="_blank">{n.titlename}</Link>
                                    </p>
                                )) : <p>No Answer Key Available</p>}
                                 <div className="BtnView" style={{ display: "flex", justifyContent: "flex-end",margin:"10px" }}>
                                    <Link to="/syllabus" style={{
                                        padding: "6px 40px",
                                        backgroundImage: "linear-gradient(135deg, #1976d2, #cc07abff)",
                                        color: "#fff",
                                        borderRadius: "6px",
                                        textDecoration: "none",
                                        fontWeight: 500,
                                        display: "inline-block"
                                    }}        
                                    >View All</Link>
                                </div>
                            </div>
                        </div>
                        <div className="col mt-3">
                            <div className="card cardItem">
                                <h6 className="title bg-danger text-white p-2 text-center">University Update</h6>
                                {university_Update.length > 0 ? university_Update.map((n, i) => (
                                    <p key={i} style={{fontWeight:"bold"}}>
                                        <Link to={`/notifactionview/${n._id}`} target="_blank">{n.titlename}</Link>
                                    </p>
                                )) : <p>No Answer Key Available</p>}
                                <div className="BtnView" style={{ display: "flex", justifyContent: "flex-end",margin:"10px" }}>
                                    <Link to="/universityUpdate" style={{
                                        padding: "6px 40px",
                                        backgroundImage: "linear-gradient(135deg, #1976d2, #cc07abff)",
                                        color: "#fff",
                                        borderRadius: "6px",
                                        textDecoration: "none",
                                        fontWeight: 500,
                                        display: "inline-block"
                                    }}        
                                    >View All</Link>
                                </div>
                            </div>
                        </div>
                        <div className="col mt-3">
                            <div className="card cardItem">
                                <h6 className="title bg-danger text-white p-2 text-center">Upcoming Job</h6>
                                {upcoming_Job.length > 0 ? upcoming_Job.map((n, i) => (
                                    <p key={i} style={{fontWeight:"bold"}}>
                                        <Link to={`/notifactionview/${n._id}`} target="_blank">{n.titlename}</Link>
                                    </p>
                                )) : <p>No Answer Key Available</p>}
                                <div className="BtnView" style={{ display: "flex", justifyContent: "flex-end",margin:"10px" }}>
                                    <Link to="/upcomingjob" style={{
                                        padding: "6px 40px",
                                        backgroundImage: "linear-gradient(135deg, #1976d2, #cc07abff)",
                                        color: "#fff",
                                        borderRadius: "6px",
                                        textDecoration: "none",
                                        fontWeight: 500,
                                        display: "inline-block"
                                    }}        
                                    >View All</Link>
                                </div>
                            </div>
                        </div>
                        <div className="col mt-3">
                            <div className="card cardItem">
                                <h6 className="title bg-danger text-white p-2 text-center">New Update</h6>
                                {new_Update.length > 0 ? new_Update.map((n, i) => (
                                    <p key={i} style={{fontWeight:"bold"}}>
                                        <Link to={`/notifactionview/${n._id}`} target="_blank">{n.titlename}</Link>
                                    </p>
                                )) : <p>No Answer Key Available</p>}
                                <div className="BtnView" style={{ display: "flex", justifyContent: "flex-end",margin:"10px" }}>
                                    <Link to="/newupdate" style={{
                                        padding: "6px 40px",
                                        backgroundImage: "linear-gradient(135deg, #1976d2, #cc07abff)",
                                        color: "#fff",
                                        borderRadius: "6px",
                                        textDecoration: "none",
                                        fontWeight: 500,
                                        display: "inline-block"
                                    }}        
                                    >View All</Link>
                                </div>
                            </div>
                        </div>
                        <div className="col mt-3">
                            <div className="card cardItem">
                                <h6 className="title bg-danger text-white p-2 text-center">Sarkari Yojana</h6>
                                {sarkari_Yojana.length > 0 ? sarkari_Yojana.map((n, i) => (
                                    <p key={i} style={{fontWeight:"bold"}}>
                                        <Link to={`/notifactionview/${n._id}`} target="_blank">{n.titlename}</Link>
                                    </p>
                                )) : <p>No Answer Key Available</p>}
                                <div className="BtnView" style={{ display: "flex", justifyContent: "flex-end",margin:"10px" }}>
                                    <Link to="/sarkariyojna" style={{
                                        padding: "6px 40px",
                                        backgroundImage: "linear-gradient(135deg, #1976d2, #cc07abff)",
                                        color: "#fff",
                                        borderRadius: "6px",
                                        textDecoration: "none",
                                        fontWeight: 500,
                                        display: "inline-block"
                                    }}        
                                    >View All</Link>
                                </div>
                            </div>
                        </div>
                        <div className="col mt-3">
                            <div className="card cardItem">
                                <h6 className="title bg-danger text-white p-2 text-center">Documents</h6>
                                {documents.length > 0 ? documents.map((n, i) => (
                                    <p key={i} style={{fontWeight:"bold"}}>
                                        <Link to={`/notifactionview/${n._id}`} target="_blank">{n.titlename}</Link>
                                    </p>
                                )) : <p>No Answer Key Available</p>}
                                <div className="BtnView" style={{ display: "flex", justifyContent: "flex-end",margin:"10px" }}>
                                    <Link to="/document" style={{
                                        padding: "6px 40px",
                                        backgroundImage: "linear-gradient(135deg, #1976d2, #cc07abff)",
                                        color: "#fff",
                                        borderRadius: "6px",
                                        textDecoration: "none",
                                        fontWeight: 500,
                                        display: "inline-block"
                                    }}        
                                    >View All</Link>
                                </div>
                            </div>
                        </div>
                        <div className="col mt-3">
                            <div className="card cardItem">
                                <h6 className="title bg-danger text-white p-2 text-center">Latest Blog</h6>
                                {latest_Blog.length > 0 ? latest_Blog.map((n, i) => (
                                    <p key={i} style={{fontWeight:"bold"}}>
                                        <Link to={`/notifactionview/${n._id}`} target="_blank">{n.titlename}</Link>
                                    </p>
                                )) : <p>No Answer Key Available</p>}
                                <div className="BtnView" style={{ display: "flex", justifyContent: "flex-end",margin:"10px" }}>
                                    <Link to="/latestblog" style={{
                                        padding: "6px 40px",
                                        backgroundImage: "linear-gradient(135deg, #1976d2, #cc07abff)",
                                        color: "#fff",
                                        borderRadius: "6px",
                                        textDecoration: "none",
                                        fontWeight: 500,
                                        display: "inline-block"
                                    }}        
                                    >View All</Link>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <Box sx={{ py: 8, background: "#f7f7f7ff" }}>
            <Box textAlign="center" sx={{mb: { xs: 3, md: 4 },
        px: { xs: 1, sm: 2 }}}>
      <Typography
        variant="h6"
        fontWeight="bold"
        sx={{
          display: "inline-block",
          position: "relative",
          background:
            "linear-gradient(270deg, #be063dff, #48b1bf, #8e2de2, #06beb6)",
          backgroundSize: "600% 600%",
          WebkitBackgroundClip: "text",
          WebkitTextFillColor: "transparent",
          animation: "gradientMove 6s ease infinite",
          pb: 1,
          fontWeight:"bold",
          fontSize: {
            xs: "18px",   // ✅ mobile
            sm: "24px",   // tablet
            md: "32px",   // laptop
            lg: "36px"    // desktop
          },
        }}
      >
       Features of Maa Sharde Digital Seva Kendra
        {/* Gradient Underline */}
        <Box
          component="span"
          sx={{
            position: "absolute",
            left: 0,
            bottom: 0,
            width: "100%",
            height: "2px",
            borderRadius: "4px",
            background:
              "linear-gradient(270deg, #06beb6, #48b1bf, #8e2de2, #06beb6)",
            backgroundSize: "600% 600%",
            animation: "gradientMove 6s ease infinite"
          }}
        />
      </Typography>

      {/* Keyframes */}
      <style>
        {`
          @keyframes gradientMove {
            0% { background-position: 0% 50%; }
            50% { background-position: 100% 50%; }
            100% { background-position: 0% 50%; }
          }
        `}
      </style>
    </Box>
            <Typography align="center" color="text.secondary" mb={5}>
                Fast, reliable & citizen-friendly digital services
            </Typography>

            <Grid container spacing={2} px={{ xs: 1, md: 8 }}>
  {features.map((item, i) => (
    <Grid
      item
      xs={4}      // 3 cards per row on mobile
      sm={6}
      md={3}
      key={i}
      sx={{ display: "flex" }}   // ⭐ important
    >
      <Card
        sx={{
          flexGrow: 1,           // ⭐ equal height
          textAlign: "center",
          borderRadius: 3,
          transition: "0.3s",
          display: "flex",
          flexDirection: "column",

          ":hover": {
            transform: "translateY(-6px)",
            boxShadow: 6
          }
        }}
      >
        <CardContent
          sx={{
            p: { xs: 1, sm: 2 },
            display: "flex",
            flexDirection: "column",
            height: "100%",
            width:{xs:"100px",sm:"150px",lg:"200px",xl:"220px"}
          }}
        >
          {/* Icon */}
          <Typography sx={{ fontSize: { xs: "22px", sm: "30px" } }}>
            {item.icon}
          </Typography>

          {/* Title */}
          <Typography
            sx={{
              fontWeight: 600,
              fontSize: { xs: "12px", sm: "14px" },
              lineHeight: 1.2,
              mb: 0.5
            }}
          >
            {item.title}
          </Typography>

          {/* Description */}
          <Typography
            sx={{
              fontSize: { xs: "10px", sm: "12px" },
              color: "text.secondary",
              lineHeight: 1.3,
              mt: "auto"          // ⭐ pushes text evenly
            }}
          >
            {item.desc}
          </Typography>
        </CardContent>
      </Card>
    </Grid>
  ))}
</Grid>
            </Box>
            <Contact/>
            <Newsletter/>
            <Footer />
        </>
    );
}
